import { useLanguage } from '@base/LanguageProvider';
import { useUpdateUserSettingsActions } from '@data/hooks/currentUser';
import { useTimePoints } from '@data/hooks/timePoints';
import { useActiveVersions } from '@data/hooks/versions';
import { useTagContext } from '@data/tag/tagContext';
import TableChart from '@shared/tablechart/TableChart';
import FinanceToolbar from '@shared/toolbar/FinanceToolbar';
import TitleBar from '@shared/toolbar/TitleBar';
import { ModelContainer, ModelNoneSelected, ModelPanel } from '@styled/Model';
import React, { useMemo } from 'react';
import { SlideDown } from 'react-slidedown';
import 'react-slidedown/lib/slidedown.css';
import useResizeObserver from 'use-resize-observer';
import { useLocalData } from '../../base/LocalDataContext';
import useModelTable from '../../data/hooks/modelTable';
import { useSelectedSheetRow, useRootSheetRow } from '../../data/sheetRow/sheetRowHooks';
import { useAuth } from '../../providers/AuthProvider';
import Finder from '../../shared/finder/Finder';
import FMDocumentToolbar from '../../shared/finder/FinderToolbar';
export function FinancePanel(_a) {
    var expandedSelectedSheetRow = _a.expandedSelectedSheetRow, hasCustomCols = _a.hasCustomCols;
    var _b = useResizeObserver(), toolbarWrapRef = _b.ref, toolbarWrapHeight = _b.height;
    var activeVersions = useActiveVersions();
    var rootSheetRow = useRootSheetRow();
    var modelTableData = useModelTable(rootSheetRow, expandedSelectedSheetRow, activeVersions);
    return (React.createElement("div", null,
        React.createElement("div", { ref: toolbarWrapRef },
            React.createElement(TitleBar, { expandedSelectedSheetRow: expandedSelectedSheetRow }),
            React.createElement(FinanceToolbar, { modelTableData: modelTableData })),
        React.createElement(TableChart, { toolbarWrapHeight: toolbarWrapHeight ? toolbarWrapHeight : 0, modelTableData: modelTableData, hasCustomCols: hasCustomCols })));
}
var FlowManager = function () {
    var _a;
    var dts = (_a = useTimePoints().data) !== null && _a !== void 0 ? _a : [];
    var L = useLanguage().L;
    var userSettings = useAuth().settings;
    var rootSheetRow = useRootSheetRow();
    var tagData = useTagContext().tagData;
    var expandedSelectedSheetRow = useSelectedSheetRow();
    var finderExpanded = userSettings.finder_expanded;
    var toggleFinderExpanded = useUpdateUserSettingsActions().toggleFinderExpanded;
    var hasCustomCols = (rootSheetRow === null || rootSheetRow === void 0 ? void 0 : rootSheetRow.customColumns) ? rootSheetRow.customColumns.length > 0 : false;
    var filterTagIds = useLocalData().filterTagIds;
    var insertedFilterTags = useMemo(function () {
        var arr = [];
        filterTagIds.forEach(function (id) {
            var tag = tagData.tagById[id];
            if (tag) {
                arr.push(tag);
            }
        });
        return arr;
    }, [filterTagIds, tagData.tagById]);
    var expandFinder = function () {
        if (!finderExpanded) {
            toggleFinderExpanded();
        }
    };
    var modelContent = React.createElement(ModelNoneSelected, null, L('Loading...'));
    if (dts.length > 0) {
        if (expandedSelectedSheetRow) {
            modelContent = (React.createElement(FinancePanel, { expandedSelectedSheetRow: expandedSelectedSheetRow, hasCustomCols: hasCustomCols }));
        }
        else {
            modelContent = React.createElement(ModelNoneSelected, null, L('No row selected'));
        }
    }
    return (React.createElement(ModelContainer, null,
        React.createElement(ModelPanel, null,
            React.createElement(FMDocumentToolbar, { insertedFilterTags: insertedFilterTags }),
            React.createElement(SlideDown, { transitionOnAppear: false }, (finderExpanded || expandedSelectedSheetRow === null) && React.createElement(Finder, { expandFinder: expandFinder }))),
        modelContent));
};
export default FlowManager;
